import usePagebuilder from '../../../../../../hooks/pagebuilder/usePagebuilder';
import { ColumnComponentInterface } from '../../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';

const AddNestedComponent = ({ component, index }: { component: ColumnComponentInterface; index: number }) => {
  const templateEditMode = useSelector((state) => state.common.templateEditMode);

  const { addComponent } = usePagebuilder();

  return (
    <>
      <button
        className="h-full min-h-[25px] w-full flex justify-center backdrop-blur-sm items-center relative text-white font-bold bg-transparent transition-all"
        onClick={() => addComponent(index, component._id)}>
        <b className={`z-10 opacity-${templateEditMode ? '100' : '0'} transition-all text-white text-4xl`}>+</b>
        <div className={`absolute top-0 left-0 h-full w-full   bg-gray-400 opacity-50 rounded-xl opacity-${templateEditMode ? '100' : '0'} transition-all`} />
      </button>
    </>
  );
};
export default AddNestedComponent;
